import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
  state: () => ({
    id: null,
    name: "",
    email: "",
    role: "",
    isAuthenticated: false,
  }),

  actions: {
    setUser(userData) {
      this.id = userData.id;
      this.name = userData.name;
      this.email = userData.email || "";
      this.role = userData.role || "";
      this.isAuthenticated = true;
    },

    clearUser() {
      this.id = null;
      this.name = "";
      this.email = "";
      this.role = "";
      this.isAuthenticated = false;
    },

    loadFromStorage() {
      const userData = localStorage.getItem("user");
      if (userData) {
        try {
          const parsed = JSON.parse(userData);
          this.setUser(parsed);
        } catch (e) {
          console.error("Error loading user from storage:", e);
        }
      }
    },
  },

  getters: {
    fullName: (state) => state.name,
    isAdmin: (state) => state.role === "admin",
  },
});
